import {AnyEvent, JOB_SECTION_DELETED, JobSectionDeletedEvent} from '../type';

export default function jobSectionDeleted(payload: JobSectionDeletedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_DELETED,
    payload,
  }
}